import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const GlobalViewState = {
  globalViewRecords: [],
  globalViewLegalCases: [],
  globalViewParties: [],
  globalViewDetails: {},
}

export const GlobalViewActions = {
  fetchGlobalViewRecords: async ({ commit }) => {
    return axiosRequest.get('/users/global_view/records').
      then(({ data }) => {
        commit('setGlobalViewRecords', data)
        return data
      }).
      catch(handleError)
  },
  fetchGlobalViewLegalCases: async ({ commit }) => {
    return axiosRequest.get('/users/global_view/legal_cases').
      then(({ data }) => {
        commit('setGlobalViewLegalCases', data)
        return data
      }).
      catch(handleError)
  },
  fetchGlobalViewParties: async ({ commit }) => {
    return axiosRequest.get('/users/global_view/parties').
      then(({ data }) => {
        commit('setGlobalViewParties', data)
        return data
      }).
      catch(handleError)
  },
  fetchGlobalViewDetails: async ({ commit }) => {
    return axiosRequest.get('/users/global_view').
      then(({ data }) => {
        commit('setGlobalViewDetails', data)
        return data
      }).
      catch(handleError)
  },
}

export const GlobalViewMutations = {
  setGlobalViewRecords: (state, records) => (state.globalViewRecords = records),
  setGlobalViewLegalCases: (state, cases) => (state.globalViewLegalCases = cases),
  setGlobalViewParties: (state, parties) => (state.globalViewParties = parties),
  setGlobalViewDetails: (state, details) => (state.globalViewDetails = details),
}

export const GlobalViewGetters = {
  globalViewRecords: state => state.globalViewRecords,
  globalViewLegalCases: state => state.globalViewLegalCases,
  globalViewParties: state => state.globalViewParties,
  globalViewDetails: state => state.globalViewDetails,
}
